'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HoldInfoMessages = require('./components/HoldInfoMessages.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HoldInfoMessages).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-hold-info-messages/lib/index.js
// module id = 1488
// module chunks = 1